// extracted by mini-css-extract-plugin
export default {"NumberBadge":"NumberBadge_NumberBadge__8ql9-"};